import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../ui/CustomCard/CustomCard";
import CustomSelect from "../../../ui/CustomSelect/CustomSelect";

const periodOptions = [
  { value: "this-year", label: "This year" },
  { value: "last-year", label: "Last year" },
  { value: "this-quarter", label: "This quarter" },
];

export function RevenueChart() {
  const data = [
    { month: "Jan", revenue: 3000 },
    { month: "Feb", revenue: 2800 },
    { month: "Mar", revenue: 4200 },
    { month: "Apr", revenue: 3600 },
    { month: "May", revenue: 2400 },
    { month: "Jun", revenue: 3800 },
  ];

  return (
    <Card className="border border-gray-200">
      <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6">
        <CardTitle className="text-sm sm:text-lg font-semibold text-gray-900">
          Revenue chart
        </CardTitle>
        <CustomSelect
          data={periodOptions}
          placeholder="Select period"
          size="xs"
          w={130}
          allowDeselect={false}
          withCheckIcon={false}
        />
      </CardHeader>
      <CardContent className="p-3 sm:p-6 pt-0">
        <div className="w-full h-[200px] sm:h-[250px] md:h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
            >
              <CartesianGrid stroke="#f1f5f9" />
              <XAxis dataKey="month" tick={{ fontSize: 10, fill: "#6b7280" }} />
              <YAxis
                tick={{ fontSize: 10, fill: "#6b7280" }}
                tickFormatter={(value) => `${value / 1000}k`}
              />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="revenue"
                stroke="#3b82f6"
                strokeWidth={2}
                dot={{ r: 3, stroke: "#3b82f6", strokeWidth: 2 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
